import { LoadingListEntityProfile } from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import { Dropdown, Empty } from "antd";
import styles from "./InstitutionPublications.module.scss";
import PublicationItem from "Explore/Components/PublicationItem";
import LoginRequiredSection from "Explore/Components/LoginRequired";
import { useState } from "react";
import useInfinityPagination from "Hooks/useInfinityPagination";
import { getInstitutionPublicationsByID } from "Explore/Services/Institution";
import InfinityPagination from "Explore/Components/Pagination/InfinityPagination";
import useExploreInfo from "Hooks/useExploreInfo";

const InstitutionPublications = ({
  institution_id,
  selectedKeywords,
  sliderValue,
}) => {
  const { entity_id: institutionIdentifier } = useExploreInfo();
  const targetInstitutionId = institution_id || institutionIdentifier;
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 20,
  });
  const [showLoginSection, setShowLoginSection] = useState(false);
  const [verified, setVerified] = useState(true);
  const { data, currentMaxPage, hasNextPage, isLoading } =
    useInfinityPagination({
      fetchFunction: getInstitutionPublicationsByID,
      page: pagination.page,
      filter: {
        id: targetInstitutionId,
        keywords: selectedKeywords,
        verified,
        startYear: sliderValue[0],
        endYear: sliderValue[1],
      },
      rowsPerPage: pagination.rowsPerPage,
      setPagination,
      errCallback: (e) => {
        if (e?.response?.status === 401) {
          setShowLoginSection(true);
        }
      },
    });

  const items = [
    {
      label: (
        <div
          style={{ width: "350px", display: "flex", flexDirection: "column" }}
          onClick={() => {
            setVerified(true);
          }}
        >
          <p style={{ fontWeight: "600" }}>Verified</p>
          <p
            style={{
              fontSize: "13px",
              color: "var(--dark-grey)",
            }}
          >
            Only display publications that have been verified as belonging to
            this author.
          </p>
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div
          style={{ width: "350px", display: "flex", flexDirection: "column" }}
          onClick={() => {
            setVerified(false);
          }}
        >
          <p style={{ fontWeight: "600" }}>All</p>
          <p
            style={{
              fontSize: "13px",
              color: "var(--dark-grey)",
            }}
          >
            Display all found publications, including those not yet verified.
          </p>
        </div>
      ),
      key: "1",
    },
  ];

  return (
    <div className={styles["institution-publications"]}>
      <Dropdown
        menu={{
          items,
        }}
        placement="top"
        arrow={{
          pointAtCenter: true,
        }}
        trigger={["click"]}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
            cursor: "pointer",
            width: "fit-content",
          }}
        >
          <p
            style={{
              color: "var(--grey-text)",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            {verified ? "Verified" : "All"}
          </p>
          {IconPack.dropDownArrow}
        </div>
      </Dropdown>
      <LoadingListEntityProfile
        isLoading={isLoading}
        component={
          (data[pagination.page - 1] || []).length > 0 ? (
            (data[pagination.page - 1] || []).map((item, index) => {
              return <PublicationItem data={item} key={index} />;
            })
          ) : showLoginSection ? (
            <LoginRequiredSection />
          ) : (
            <Empty description="No Publication Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={false}
      />
      <InfinityPagination
        style={{ marginTop: "20px" }}
        currentMaxPage={currentMaxPage}
        pagination={pagination}
        setPagination={setPagination}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        sizeChanger
      />
    </div>
  );
};

export default InstitutionPublications;
